import store from 'store';
import moment from 'moment';
import { hasPermissions } from 'helpers/permissionsHelpers';

const statusLabels = {
  DRAFT: { text: 'Brouillon', type: 'info' },
  REFUSED: { text: 'Déclaration refusée', type: 'error' },
  CANCELLED: { text: 'Déclaration annulée ', type: 'error' },
  ACCEPTED: { text: 'Déclaration acceptée', type: 'success' },
  // Specific for N1 and N2
  TO_EVALUATE: { text: 'À évaluer', type: 'warning' },
  WAIT_NIV1: {
    text: 'En cours d\'évaluation par l\'instructeur de Niv 1',
    type: 'warning',
  },
  WAIT_OTHERS_NIV1: {
    text: 'En cours d\'évaluation par d\'autres instructeurs de Niv 1',
    type: 'warning',
  },
  WAIT_NIV2: {
    text: 'En cours d\'évaluation par l\'instructeur de Niv 2',
    type: 'warning',
  },
  WAIT_USER: {
    text: "En attente d'éléments de la part du demandeur",
    type: 'warning',
  },
  // Specific for user
  WAITING: { text: 'En cours de traitement', type: 'warning' },
  TO_COMPLETE: {
    text: "En attente d'éléments supplémentaires de votre part",
    type: 'warning',
  },
  NO_STATUS: { text: 'Pas de statut connu', type: 'warning' },
};

const allN1approved = approbations => !Object.values(approbations).includes(0);
const isWaitingForUser = approbations => Object.values(approbations).includes(1);
const isWaitingForN1 = (user, approbations) =>
  approbations[user.uuid] !== 0 && Object.values(approbations).includes(0);

/**
 * getUserrequestStatus
 *
 * @param {object} user - user's data
 * @param {object} userrequest - userrequest's data
 *
 */
const getUserrequestStatus = (userrequest, user) => {
  const { states } = store.getState().appConfig;
  const { properties: { approbations } } = userrequest;

  const expiry = userrequest.expiry
    ? `avant le ${moment(userrequest.expiry).format('DD/MM/YYYY')}`
    : '';
  const { permissions } = user;


  // Same label for all groups
  if (userrequest.state === states.DRAFT) {
    return statusLabels.DRAFT;
  }

  if (userrequest.state === states.REFUSED) {
    return statusLabels.REFUSED;
  }

  if (userrequest.state === states.ACCEPTED) {
    return statusLabels.ACCEPTED;
  }

  if (userrequest.state === states.CANCELLED) {
    return statusLabels.CANCELLED;
  }

  // Specific labels for N1
  if (hasPermissions(permissions, ['actions.can_approve_requests'])) {
    if (allN1approved(approbations)) {
      // Current N1 already approved, need N2
      if (isWaitingForUser(approbations)) {
        return statusLabels.WAIT_USER;
      }
      return statusLabels.WAIT_NIV2;
    }
    if (isWaitingForN1(user, approbations)) {
      return statusLabels.WAIT_OTHERS_NIV1;
    }
    return {
      ...statusLabels.TO_EVALUATE,
      text: `${statusLabels.TO_EVALUATE.text} ${expiry}`,
    };
  }

  // Specific labels for N2
  if (hasPermissions(permissions, ['trrequests.can_change_state_requests'])) {
    if (userrequest.state === states.SUBMITTED) {
      return {
        ...statusLabels.TO_EVALUATE,
        text: `${statusLabels.TO_EVALUATE.text} ${expiry}`,
      };
    }
  }

  // Specific labels for users
  if (userrequest.state === states.SUBMITTED) {
    if (isWaitingForUser(approbations)) {
      return statusLabels.TO_COMPLETE;
    }
    return statusLabels.WAITING;
  }

  return statusLabels.NO_STATUS;
};

export default getUserrequestStatus;



// WEBPACK FOOTER //
// ./src/modules/userrequestStatus.js